import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { ClientWithTasks } from '../../types/models';
import { ClientCard } from './ClientCard';

interface SortableClientCardProps {
  client: ClientWithTasks;
  onOpen: () => void;
  onEdit: () => void;
  onToggleTask: (taskId: string) => void;
  onAddTask: (title: string) => void;
  onCursor: (title: string) => void;
  onSelectTask: (taskId: string) => void;
  onToggleLineup: (taskId: string) => void;
}

/** Wraps ClientCard with dnd-kit sortable behavior; only the drag handle
 *  activates a drag, so the rest of the card stays interactive. */
export function SortableClientCard(props: SortableClientCardProps) {
  const {
    attributes,
    listeners,
    setNodeRef,
    setActivatorNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props.client.id });

  const style: React.CSSProperties = {
    // Translate only — never scale — so cards of different sizes don't warp
    // while being dragged in the mosaic.
    transform: CSS.Translate.toString(transform),
    transition,
    zIndex: isDragging ? 20 : undefined,
    opacity: isDragging ? 0.9 : 1,
    // Avoids hover-lift flicker and lets pointer events fall through to the
    // drop targets underneath while a card is in flight.
    pointerEvents: isDragging ? 'none' : undefined,
  };

  return (
    <div ref={setNodeRef} style={style}>
      <ClientCard
        {...props}
        dragHandleRef={setActivatorNodeRef}
        dragHandleProps={{ ...attributes, ...listeners }}
      />
    </div>
  );
}
